import { render, staticRenderFns } from "./PaymentGatewayWithFreeDomainMigration.vue?vue&type=template&id=2e088d66&"
import script from "./PaymentGatewayWithFreeDomainMigration.vue?vue&type=script&lang=js&"
export * from "./PaymentGatewayWithFreeDomainMigration.vue?vue&type=script&lang=js&"
import style0 from "./PaymentGatewayWithFreeDomainMigration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e088d66')) {
      api.createRecord('2e088d66', component.options)
    } else {
      api.reload('2e088d66', component.options)
    }
    module.hot.accept("./PaymentGatewayWithFreeDomainMigration.vue?vue&type=template&id=2e088d66&", function () {
      api.rerender('2e088d66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/PaymentGatewayWithFreeDomainMigration.vue"
export default component.exports